import type { DatasetsMutatorCreateProps } from "./datasets-mutator-create.type";

import DatasetsMutatorCreateDataset from "../datasets-mutator-create-dataset";
import DatasetsMutatorCreateDatasets from "../datasets-mutator-create-datasets";
import { useDatasetMutatorGetCreateItems } from "../datasets-mutator.hook";

const DatasetsMutatorCreate = ({
  interventionId,
  sectionLayoutIndex,
  sectionAssetId,
  sectionObservationId,
  onObservationCreate,
  invalidateKeys,
}: DatasetsMutatorCreateProps) => {
  const { items, hasItems } = useDatasetMutatorGetCreateItems();

  if (!hasItems) return null;

  if (sectionObservationId) {
    return items.map((item) => (
      <DatasetsMutatorCreateDataset
        key={item.mutationKey}
        sectionObservationId={sectionObservationId}
        mutatorItem={item}
        invalidateKeys={invalidateKeys}
      />
    ));
  }

  if (sectionLayoutIndex) {
    return (
      <DatasetsMutatorCreateDatasets
        interventionId={interventionId}
        sectionLayoutIndex={sectionLayoutIndex}
        sectionAssetId={sectionAssetId}
        mutatorItems={items}
        onObservationCreate={onObservationCreate}
        invalidateKeys={invalidateKeys}
      />
    );
  }

  return null;
};

export default DatasetsMutatorCreate;
